const getters = {
  userInfo: state => state.app.userInfo,
  identityName: state => state.app.identityName,
  identityId: state => state.app.identityId,
  ossToken: state=> state.app.ossToken
}
export default getters
